import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { fetchCustomers } from '../actions/customerAction';
import CustomerTable from '../components/Customers/CustomerTable';
import Layout from '../components/Layout/Layout';


const Customers = ( { customerInfo, loading, msg, isAuthenticated, fetchCustomers }: any ) => {
    
    // To be implemented hard referesh as difference componnent
    
    useEffect( ( ) => { 

        console.log( 'inside customer effect ', customerInfo );
        if ( !customerInfo ) {

            fetchCustomers( );

        }
        else {
            console.log( 'Already Fetched' );
        }

    }, [  ] );

    return (
        
        <Layout>
            <CustomerWrapper>
                <div className="main-container">
                    <div className="header-container">
                        <div className="heading">
                            {/* <h2>Heading component</h2> */}
                        </div>
                        <div className="filters">
                            {/* <h2>Filter area</h2> */}
                        </div>
                    </div>
                    <div className="table-container">
                        {
                            loading ?
                            <h3>Loading component ... </h3>
                            :
                            <div>
                                {
                                    !customerInfo ?
                                    <h3>No Customer Available</h3>
                                    :
                                    <CustomerTable customerInfo = { customerInfo } />
                                }
                            </div>
                        }
                    </div>
                </div>
            </CustomerWrapper>
        </Layout>
    )
}

const mapStateToProps = ( state: any ) => ( { 

    isAuthenticated: state.admin.isAuthenticated,
    loading: state.customer.loading,
    msg: state.customer.msg,
    customerInfo: state.customer.customerInfo

} );

export default connect( mapStateToProps, {

    fetchCustomers

} ) ( Customers );


const CustomerWrapper = styled.div`


`;